import { ROUTES } from '@shared/config/routes'

// Warm a route's lazy page chunk before the user clicks — triggered on nav-link
// hover/focus (see Sidebar). Each thunk is a dynamic `import()` of the SAME module
// the router lazy-loads, so Vite dedupes it to one chunk: this only prefetches,
// never duplicates. Covers the primary navigation surface (sidebar nav + profile).
const ROUTE_PREFETCH: Record<string, () => Promise<unknown>> = {
  // Admin
  [ROUTES.ADMIN]: () => import('@pages/admin/dashboard'),
  [ROUTES.ADMIN_USERS]: () => import('@pages/admin/users'),
  [ROUTES.ADMIN_OLYMPIADS]: () => import('@pages/admin/olympiads'),
  [ROUTES.ADMIN_TASKS]: () => import('@pages/admin/tasks'),
  [ROUTES.ADMIN_RESULTS]: () => import('@pages/admin/results'),
  [ROUTES.ADMIN_CERTIFICATES]: () => import('@pages/admin/certificates'),
  [ROUTES.ADMIN_PAYMENTS]: () => import('@pages/admin/payments'),
  [ROUTES.ADMIN_CHAT]: () => import('@pages/admin/messages'),
  [ROUTES.ADMIN_PROFILE]: () => import('@pages/admin/profile'),
  // Participant
  [ROUTES.PARTICIPANT_DASHBOARD]: () => import('@pages/participant/dashboard'),
  [ROUTES.PARTICIPANT_OLYMPIADS]: () => import('@pages/participant/olympiads'),
  [ROUTES.PARTICIPANT_TASKS]: () => import('@pages/participant/tasks'),
  [ROUTES.PARTICIPANT_RATE_OVERALL]: () => import('@pages/participant/rate-overall'),
  [ROUTES.PARTICIPANT_CERTIFICATES]: () => import('@pages/participant/certificates'),
  [ROUTES.PARTICIPANT_INSTRUCTIONS]: () => import('@pages/participant/instructions'),
  [ROUTES.PARTICIPANT_FAQ]: () => import('@pages/participant/faq'),
  [ROUTES.PARTICIPANT_PAYMENTS]: () => import('@pages/participant/payments'),
  [ROUTES.PARTICIPANT_PERSONAL]: () => import('@pages/participant/personal'),
  // Representative
  [ROUTES.REPRESENTATIVE]: () => import('@pages/representative/dashboard'),
  [ROUTES.REPRESENTATIVE_MEMBERS]: () => import('@pages/representative/members'),
  [ROUTES.REPRESENTATIVE_RESULTS]: () => import('@pages/representative/results'),
  [ROUTES.REPRESENTATIVE_CHAT]: () => import('@pages/representative/chat'),
  [ROUTES.REPRESENTATIVE_PROFILE]: () => import('@pages/representative/profile'),
}

const prefetched = new Set<string>()

/** Fire-and-forget prefetch of a route's chunk. Safe to call repeatedly — each
 *  route is warmed at most once. */
export function prefetchRoute(path: string): void {
  if (prefetched.has(path)) return
  const load = ROUTE_PREFETCH[path]
  if (!load) return
  prefetched.add(path)
  void load()
}
